module.exports = __webpack_public_path__ + "static/img/有獎徵答300.b2acc6a1.png";